import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_image",
  "use": "micro_image-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_image\"><path fill-rule=\"evenodd\" d=\"M4 6 3 4 1 8h8L6 2 4 6ZM0 2C0 .895.887 0 2 0h6c1.105 0 2 .887 2 2v6c0 1.105-.887 2-2 2H2c-1.105 0-2-.887-2-2V2Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol